import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GitMerge, Split } from "lucide-react";

export default function EntityReview() {
  const [d, setD] = useState(null);
  const load = () => api.get("/entity/pending").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  if (!d) return <div className="p-8 text-[#71717A] font-mono text-sm">Loading…</div>;

  const act = (id, kind) => api.post(`/entity/${id}/${kind}`).then(load);

  return (
    <div className="p-8 max-w-[1100px]">
      <h1 className="font-head text-2xl font-bold tracking-tight mb-1">Entity Review</h1>
      <p className="text-xs font-mono text-[#71717A] mb-6">
        AI/fuzzy suggested product merges. Identity is auditable — approve to merge, split to keep separate.
      </p>

      <h2 className="text-[11px] uppercase tracking-widest text-[#71717A] font-mono mb-2">Pending [{d.pending.length}]</h2>
      {d.pending.length === 0 ? (
        <div className="border border-dashed border-[#27272A] p-6 text-center text-xs font-mono text-[#71717A]">No pending suggestions.</div>
      ) : (
        <div className="space-y-3">
          {d.pending.map((s) => (
            <div key={s.id} data-testid={`suggestion-${s.id}`} className="border border-[#27272A] bg-[#18181B] p-4">
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div className="flex items-center gap-3 font-mono text-sm">
                  <span className="text-[#F4F4F5]">{s.source_name}</span>
                  <span className="text-[#71717A]">→ merge into →</span>
                  <span className="text-emerald-400">{s.candidate_name}</span>
                  <span className="text-[10px] text-indigo-400 border border-indigo-800 bg-indigo-950 px-2 py-0.5">
                    confidence {Math.round(s.confidence * 100)}% · {s.matched_by}
                  </span>
                </div>
                <div className="flex gap-2">
                  <button
                    data-testid={`merge-${s.id}`}
                    onClick={() => act(s.id, "merge")}
                    className="flex items-center gap-1 text-xs font-mono bg-emerald-500 text-[#09090B] px-3 py-1.5 hover:bg-emerald-400"
                  >
                    <GitMerge size={13} /> Merge
                  </button>
                  <button
                    data-testid={`split-${s.id}`}
                    onClick={() => act(s.id, "split")}
                    className="flex items-center gap-1 text-xs font-mono border border-[#3f3f46] text-[#A1A1AA] px-3 py-1.5 hover:text-[#F4F4F5]"
                  >
                    <Split size={13} /> Keep separate
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {d.resolved.length > 0 && (
        <>
          <h2 className="text-[11px] uppercase tracking-widest text-[#71717A] font-mono mt-8 mb-2">Resolved</h2>
          <div className="space-y-1">
            {d.resolved.map((s) => (
              <div key={s.id} className="flex items-center justify-between border border-[#1c1c1f] px-4 py-2 font-mono text-xs">
                <span className="text-[#A1A1AA]">
                  {s.source_name} → {s.candidate_name}
                </span>
                <span className={s.status === "merged" ? "text-emerald-400" : "text-[#71717A]"}>{s.status}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
